<template>
    <div v-if="prorate.taxes_amount" class="columns is-marginless is-small-marginless">
        <div
            class="column is-9"
            :class="{
                'is-paddingless': paddingless,
            }"
        >
            <span>
                {{ taxTitle }}
            </span>
        </div>

        <div
            class="column is-3 has-text-right"
            :class="{
                'is-paddingless': paddingless,
            }"
        >
            {{ $filters.currency(prorate.taxes_amount, 2) }}
        </div>
    </div>
</template>

<script>
export default {
    props: {
        prorate: { type: Object, required: true },
        paddingless: { type: Boolean, required: false },
    },

    computed: {
        taxTitle() {
            if (Array.isArray(this.prorate?.tax_rates) && this.prorate?.tax_rates?.length !== 0) {
                let taxStates = '';
                this.prorate.tax_rates.forEach((state) => {
                    if (state.jurisdiction)
                        taxStates = taxStates
                            ? `${taxStates} / ${state.jurisdiction}`
                            : state.jurisdiction;
                });

                if (taxStates) return `Salex Tax - ${taxStates}`;

                return 'Salex Tax';
            } else {
                return 'Salex Tax';
            }
        },
    },
};
</script>
